"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicColumns = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const dynamicColumns_1 = require("../../../../ui/components/EntityTable/dynamicColumns");
const react_1 = __importDefault(require("react"));
function buildDynamicColumns(dynamicColumnData) {
    if (dynamicColumnData) {
        return dynamicColumnData.columnDefs
            .filter((columnDef) => { var _a; return (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInTable; })
            .map((columnDef) => {
            var _a;
            return ({
                headerLabel: (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.label,
                cellFunction: (row) => {
                    var _a, _b;
                    return (react_1.default.createElement(DataTable_1.TextCell, null, (0, dynamicColumns_1.formatDynamicColumnValue)(row, columnDef, dynamicColumnData.handlerMap.get((_b = (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName) !== null && _b !== void 0 ? _b : ''))));
                },
            });
        });
    }
    else {
        return [];
    }
}
exports.buildDynamicColumns = buildDynamicColumns;
